

































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import Input from '@/components/common/elements/Input.vue';

@Component({
  components: { Label, Input },
})
export default class InputArea extends Vue {
  /** ラベルのname属性 */
  @Prop({ default: '' })
  private labelName!: string;
  /** ラベル内テキスト */
  @Prop({ default: '' })
  private labelText!: string;
  /** 追加付与クラス */
  @Prop({ default: '' })
  private labelClass?: string;
  /** 要素タイプ */
  @Prop({ default: 'text' })
  private inputType?: string;
  /** 入力要素名 */
  @Prop({ default: '' })
  private name!: string;
  /** 入力要素初期値 */
  @Prop({ default: '' })
  private value?: string;
  /** 入力要素プレースホルダ */
  @Prop({ default: '' })
  private placeholder?: string;
  /** 入力要素最大入力数 */
  @Prop({ default: '' })
  private maxlength?: string;
  /** 入力要素がアクティブか否か */
  @Prop({ default: false })
  private isDisabled?: boolean;
  /** テキストフィールド内後方にセットされるアイコンv */
  @Prop({ default: '' })
  private appendIcon?: string;
  /** バリデーションルール */
  @Prop({ default: '' })
  private rules?: string;
  /** 数値項目を3桁カンマ区切りで表現する設定 */
  @Prop({ default: false })
  private isCommaNumber?: boolean;

  /**
   * 親コンポーネントに子コンポーネントの値を通知する
   * @module inputOperation
   * @param {[k: string]: string} data- input要素名と値
   * @return {[k: string]: string} data - input要素名と値
   */
  @Emit('inputOperation')
  public inputOperation(data: { name: string; value: string; type?: string }) {
    data.type = this.inputType;
    return data;
  }
}
